var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 24.1818C19.6231 24.1818 24.1816 19.6233 24.1816 14C24.1816 8.37674 19.6231 3.81818 13.9998 3.81818C8.37652 3.81818 3.81797 8.37674 3.81797 14C3.81797 15.8298 4.30064 17.5469 5.14561 19.0308L3.30542 23.773L7.90378 22.156C9.60324 23.4283 11.7135 24.1818 13.9998 24.1818ZM12.8291 12.6215C12.8291 13.2631 13.3541 13.7881 13.9958 13.7881C14.6375 13.7881 15.1625 13.2631 15.1625 12.6215V10.2881C15.1625 9.64647 14.6375 9.12147 13.9958 9.12147C13.3541 9.12147 12.8291 9.64647 12.8291 10.2881V12.6215ZM12.8291 18.4548H15.1625V16.1215H12.8291V18.4548Z",
    fill: "#E15E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentWarning);
export default __webpack_public_path__ + "static/media/CommentWarning.23ed2ba61ff3463188dbc9cc6b4fd816.svg";
export { ForwardRef as ReactComponent };